import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      if (window.location.pathname.startsWith('/admin')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

// Contacts
export const createContact = (data) => api.post('/api/contacts', data);
export const getContact = (id) => api.get(`/api/contacts/${id}`);

// Chat
export const getChatSession = (contactId) => api.get(`/api/chat/${contactId}`);
export const sendMessage = (contactId, message) =>
  api.post(`/api/chat/${contactId}/message`, { message });

// Documents
export const uploadDocument = (contactId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post(`/api/documents/${contactId}/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
export const getDocuments = (contactId) => api.get(`/api/documents/${contactId}`);
export const downloadDocument = (id) => api.get(`/api/documents/download/${id}`);

// Reports
export const generateReport = (contactId) => api.post(`/api/reports/${contactId}/generate`);
export const downloadReport = (contactId) => api.get(`/api/reports/${contactId}/download`);
export const getReports = (contactId) => api.get(`/api/reports/${contactId}`);

// Admin Auth
export const adminLogin = (email, password) =>
  api.post('/api/admin/login', { email, password });
export const getMe = () => api.get('/api/admin/me');

// Admin Contacts
export const getAdminContacts = (params) => api.get('/api/admin/contacts', { params });
export const getAdminContactDetail = (id) => api.get(`/api/admin/contacts/${id}`);
export const updateContactStatus = (id, status) =>
  api.patch(`/api/admin/contacts/${id}`, { status });

// Admin Stats
export const getAdminStats = () => api.get('/api/admin/stats');

// Admin Users
export const getAdminUsers = () => api.get('/api/admin/users');
export const createAdminUser = (data) => api.post('/api/admin/users', data);

export default api;
